// extracted by mini-css-extract-plugin
export default {"container":"PaymentResult_container__IVztk","icon":"PaymentResult_icon__1d57f"};